  import React, { useEffect, useState } from 'react';
  
  import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AppLayout from './AppLayout';
  import { AccessDeniedPage } from './pages/AccessDeniedPage/AccessDeniedPage';
  import VendorListPage from './pages/VendorListPage/VendorListPage';
  import VendorDraftListPage from './pages/VendorDraftListPage/VendorDraftListPage'
  import DashboardPage from './pages/DashboardPage/DashboardPage';
  import LoginPage from './pages/Login/LoginPage';
  import { NotFoundPage } from './pages/NotFoundPage/NotFoundPage';
  import ProtectedRoute from './utils/ProtectedRoute';
  import { ToastContainer } from 'react-toastify';
import { getUserSession } from './utils/auth';
import InvoiceGenerationListPage from './pages/InvoiceGenerationListPage/InvoiceGenerationListPage';
import { VendorViewPage } from './pages/VendorViewPage/VendorViewPage';
import VendorDetails from './pages/VendorDetails';
import { InvoiceViewPage } from './pages/InvoiceViewPage/InvoiceViewPage';
import DownloadInvoice from './pages/DownloadInvoices/DownloadInvoice';
import VendorSavedDraftDetails from './pages/VendorSavedDraftDetails';


  function App() {
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
      const userData = getUserSession();
      if (userData) {
        // If user data is found in local storage, redirect to the dashboard
        setIsLoggedIn(true);
      }
    }, []);
    return (
      <Router>
    <div className='appContainer'>
    <ToastContainer />

          {/* <Sidebar /> */}
          <div className="content">
            <Routes>

              {!isLoggedIn?
              <>
              <Route path="/" element={<LoginPage />} />
              <Route path="/access-denied" element={<AccessDeniedPage />} />
              <Route path="*" element={<NotFoundPage />} /></>
:<>
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                    <DashboardPage />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
             
              <Route
                path="/Vendors"
                element={
                  <ProtectedRoute>
                    <AppLayout>

                    <VendorListPage />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
               <Route
                path="/View-Vendor"
                element={
                  <ProtectedRoute>
                    <AppLayout>

                    <VendorViewPage />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
             <Route
                path="/draftVendorList"
                element={
                  <ProtectedRoute>
                    <AppLayout>

                    <VendorDraftListPage />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/InvoiceList"
                element={
                  <ProtectedRoute>
                                        <AppLayout>

                    <InvoiceGenerationListPage />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route 
              path='/VendorDetails'
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <VendorDetails />
                  </AppLayout>
                </ProtectedRoute>
              }
              />
               <Route 
              path='/VendorSavedDraftDetails'
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <VendorSavedDraftDetails />
                  </AppLayout>
                </ProtectedRoute>
              }
              />
                <Route 
              path='/InvoiceDetails'
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <InvoiceViewPage />
                  </AppLayout>
                </ProtectedRoute>
              }
              />
                <Route 
              path='/downloadInvoice'
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <DownloadInvoice />
                  </AppLayout>
                </ProtectedRoute>
              }
              />
              <Route path="*" element={<NotFoundPage />}/>
              
              </>}
            </Routes>
          </div>
        </div>
      </Router>
    );
  }

  export default App;
